// extracted by mini-css-extract-plugin
export default {"wrapper":"display_wrapper__B4lN8","wrapper2":"display_wrapper2__-m+i0"};